import { TimeDuration } from '@/features/employee-data/employee-data.def.ts'

export type TriggerOffboardingRequest = {
  employeeId: string
  employmentId: number
  requireChecklist: boolean
  checklistConfigId?: number
}

export type OffboardingDetails = {
  noticePeriodDuration: TimeDuration
  noticePeriodStartDate?: string | null
  terminationDate?: string | null
  lastWorkingDay?: string | null
  terminationType?: string | null
  terminationReason?: string | null
  voluntaryResignationReason?: string | null
  terminationRemarks?: string | null
}

export type OffboardingRecord = {
  id: number
  employeeId: string
  status: string
  country: string
  displayName?: string
  lineManagerEmployeeId?: string
  employmentId?: number | null
  checklistId?: number | null
  details: OffboardingDetails
}

export type OffboardingRecordRequest = {
  offboardingRecordId: number
}

export type CreateOffboardingChecklistRequest = {
  offboardingRecordId: number
  checklistConfigId?: number
}

export const OffboardingStatus = {
  InProgress: 'In Progress',
  Completed: 'Completed',
  Discarded: 'Discarded',
}

export type DiscardOffboardingRecordRequest = {
  offboardingRecordId: number
}


export type CompleteOffboardingRecordRequest = {
  offboardingRecordId: number
}
